import {
  CollectionSessionMention,
  NoteSessionMention,
  SessionContextMention,
} from "../../session.types";
import { MDSIconKind } from "@/mds/components/icon";

export const getId = ({ mention }: { mention: SessionContextMention }) => {
  if (mention.kind === "NOTE") {
    return (mention as NoteSessionMention).note_id;
  }

  return (mention as CollectionSessionMention).collection_id;
};

export const getDisplayText = ({ mention }: { mention: SessionContextMention }) => {
  if (mention.kind === "NOTE") {
    return (mention as NoteSessionMention).note_primary_label;
  }

  return (mention as CollectionSessionMention).collection_title;
};

export const getIconKind = ({ mention }: { mention: SessionContextMention }) => {
  return mention.kind === "NOTE" ? MDSIconKind.Document : MDSIconKind.Collection;
};
